export const VALID_FILE_TYPES = ['text/plain', 'text/csv']
export const INVALID_FORMAT_MESSAGE_ERROR = 'Invalid file format'

export const readFile = (file: Blob): Promise<string> => {
  try {
    if (!VALID_FILE_TYPES.includes(file.type))
      throw new Error(INVALID_FORMAT_MESSAGE_ERROR)
    const reader = new FileReader()
    reader.readAsText(file, 'UTF-8')
    return new Promise((resolve) => {
      reader.onload = (e) => {
        if (e.target && typeof e.target.result === 'string') {
          resolve(e.target.result)
          return
        }
      }
    })
  } catch (err) {
    throw err
  }
}
